<template>
  <div class="agreement">
    <p>
      <span>《用户条款》</span>和<span>《隐私政策》</span>条款
    </p>
  </div>
</template>

<script>
export default {
  name: "agreement",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang='less' scoped>
.agreement {
    font-size: 16px;
    span {
        color: #F62560;
    }
}
</style>